export enum StudyType {
  Standard = 387,
  NonStandard = 388,
  Test = 389,
}
